import Debug from 'debug';
import {LitElement, html, css} from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { extractTextFromScripts, waitWithLogging } from '../utils';
import { sqliteBroker } from '../services/SqliteBroker';
import { Refreshable, RefreshSignalMixin } from '../flow/_refreshSignalMixin';

const log = Debug('pdq:sqlite:statement');
@customElement('pdq-sqlite-statement')
export class PdqSqliteStatement extends RefreshSignalMixin(LitElement) implements Refreshable {

  @property({ type: String }) database: undefined|string;
  @property({ type: String }) alias = 'main'
  private statement: string;

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(changedProperties);
  }
  render() {
    return html`
      <slot style="display: none" name="statement" @slotchange="${this._onSlotChange}"></slot>
    `;
  }
  async refresh() {
    debugger
    if (!this.statement || !this.database) {
      log(`refresh: statement or database is not set, statement cannot be applied`)
      return
    }

    await waitWithLogging(log, sqliteBroker.getDatabaseReadyPromise(this.database),
      `Waiting for database[${this.database}] to be ready...`)

    const start = performance.now()
    log(`statement changed to ${this.statement}`);
    const client = await sqliteBroker.getDatabaseClient(this.database, this.alias, `pdq:sqlite:statement`)
    log(`got client`)
    await client.query(this.statement);
    log(`statement executed in ${performance.now() - start}ms`)
  }
  protected async _onSlotChange(event: Event){
    if (!this.database) {
      log(`WARNING: database is not set, statement cannot be applied`)
      return
    }
    try {
      const slot = event.target as HTMLSlotElement;
      const nodes = slot.assignedNodes({ flatten: true });
      this.statement = extractTextFromScripts(nodes);
      await this.refresh()
    } catch (e) {
      console.error(`Failed to parse statement`, e);
    }
  }
}